import { Pipe, PipeTransform } from '@angular/core';
import { EntityTag } from '@coin/shared/core/util-models';

@Pipe({
  name: 'tagTooltip',
  standalone: false
})
export class TagTooltipPipe implements PipeTransform {
  public transform(tag: EntityTag): string {
    return [tag.shortText, tag.longText].filter(text => !!text).join('\n\n');
  }
}
